import { render, staticRenderFns } from "./TestBankQuestionCard.vue?vue&type=template&id=e2fb3944&scoped=true"
import script from "./TestBankQuestionCard.vue?vue&type=script&lang=js"
export * from "./TestBankQuestionCard.vue?vue&type=script&lang=js"
import style0 from "./TestBankQuestionCard.vue?vue&type=style&index=0&id=e2fb3944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fb3944",
  null
  
)

export default component.exports